import React, { Fragment, useEffect, useState } from 'react'
import styled from '@emotion/styled'

import { grayLight30 } from '../../constants/principles'
import { BrowserUtils, QuestionUtils } from '../../utils/siteUtils'
import { FlexDiv } from '../generic/Basics'
import Spinner from '../generic/spinner.js'

export default ({ svgItems, bodyStyle, setShowModal, height = '175px', width = '400px', addMolding = false, conditionQuestions = [], anyAnswered, make, model, setBadgeCnt, secondaryTabExterior, secondaryTabInterior, children }) => {
  if (make.displayName.toUpperCase() === 'JEEP') {
    if (model.displayName.toUpperCase().indexOf('WRANGLER') > -1) bodyStyle = 'Wrangler'
    else if (model.displayName.toUpperCase().indexOf('GLADIATOR') > -1) bodyStyle = 'Gladiator'
  }
  const [allSvgs, setAllSvgs] = useState()
  const isDesktop = BrowserUtils.isDesktop()
  const subsectionCodes = Array.from(
    conditionQuestions.reduce((acc, question) => {
      return acc.add(question.subsectionCode)
    }, new Set())
  ).filter(item => !!item)

  const onClick = nameOverride => (name, state, toggle) => {
    const [subsection, item] = name.split('|')
    const subsectionCode = subsectionCodes.find(code => (nameOverride || subsection).toLowerCase().includes(code.toLowerCase()))
    setShowModal({
      name: item,
      subsectionCode,
      onChange: anyTrue => {
        toggle && toggle(anyTrue)
      }
    })
  }

  useEffect(() => {
    import('../compiledSVG/conditionV2/Convertible').then(Module => {
      setAllSvgs(x => ({ ...x, Convertible: Module }))
    })
    import('../compiledSVG/conditionV2/Coupe').then(Module => {
      setAllSvgs(x => ({ ...x, Coupe: Module }))
    })
    import('../compiledSVG/conditionV2/Generic').then(Module => {
      setAllSvgs(x => ({ ...x, Generic: Module }))
    })
    import('../compiledSVG/conditionV2/Hatchback').then(Module => {
      setAllSvgs(x => ({ ...x, Hatchback: Module }))
    })
    import('../compiledSVG/conditionV2/Sedan').then(Module => {
      setAllSvgs(x => ({ ...x, Sedan: Module }))
    })
    import('../compiledSVG/conditionV2/Suv').then(Module => {
      setAllSvgs(x => ({ ...x, Suv: Module }))
    })
    import('../compiledSVG/conditionV2/Truck').then(Module => {
      setAllSvgs(x => ({ ...x, Truck: Module, Pickup: Module }))
    })
    import('../compiledSVG/conditionV2/Van').then(Module => {
      setAllSvgs(x => ({ ...x, Van: Module, Passenger: Module, Cargo: Module }))
    })
    import('../compiledSVG/conditionV2/Wagon').then(Module => {
      setAllSvgs(x => ({ ...x, Wagon: Module }))
    })
    import('../compiledSVG/conditionV2/Wrangler').then(Module => {
      setAllSvgs(x => ({ ...x, Wrangler: Module }))
    })
    import('../compiledSVG/conditionV2/Gladiator').then(Module => {
      setAllSvgs(x => ({ ...x, Gladiator: Module }))
    })
  }, [])

  const svgs = allSvgs && allSvgs[bodyStyle] ? svgItems.map(item => allSvgs[bodyStyle][item] || allSvgs[bodyStyle][item.slice(0, -1)]) : null
  const Moulding = allSvgs && allSvgs.Generic ? allSvgs.Generic.Molding : null

  return svgs ? (
    svgs.map((Svg, index) => {
      const representativeQuestion = conditionQuestions.find(question => question.subsectionCode && svgItems && svgItems[index].toLowerCase().includes(question.subsectionCode))
      const curState =
        representativeQuestion &&
        QuestionUtils.getItems(conditionQuestions, representativeQuestion.subsectionCode)
          .map(item => ({
            [item]: anyAnswered(QuestionUtils.getAssociatedQuestions(conditionQuestions, item, representativeQuestion.subsectionCode))
          }))
          .reduce((acc, cur) => {
            acc[Object.keys(cur)[0]] = Object.values(cur)[0]
            return acc
          }, {})

      //add tires & rims
      if (svgItems[index].toLowerCase().includes('driver') || svgItems[index].toLowerCase().includes('passenger')) {
        QuestionUtils.getItems(conditionQuestions, 'WheelsBrakes')
          .map(item => ({
            [item]: anyAnswered(QuestionUtils.getAssociatedQuestions(conditionQuestions, item, 'WheelsBrakes'))
          }))
          .reduce((acc, cur) => {
            if (Object.keys(cur)[0] === 'tiresrims') acc[Object.keys(cur)[0]] = Object.values(cur)[0]
            return acc
          }, curState)
      }

      const isVisible =
        representativeQuestion.subsectionCode.toLowerCase().includes(secondaryTabExterior === 'Windows' ? 'glass' : secondaryTabExterior.toLowerCase()) ||
        (representativeQuestion.subsectionCode.toLowerCase() === 'interior' && secondaryTabInterior === 'Seats')

      return (
        <Fragment key={index}>
          <SpacedDiv>
            {Svg && (
              <Svg
                height={isDesktop ? height + 'px' : height * 0.75 + 'px'}
                width={isDesktop ? width + 'px' : width * 0.75 + 'px'}
                {...curState}
                onClick={(...args) => onClick()(...args)}
                isDesktop={isDesktop}
                setBadgeCnt={setBadgeCnt}
                isVisible={isVisible}
              />
            )}
            <BottomDiv>
              {addMolding && Svg && Moulding && (
                <Moulding
                  width={isDesktop ? '150px' : '120px'}
                  height="40px"
                  molding={curState && curState.moldingtrim}
                  onClick={(...args) => onClick(svgItems && svgItems[index])(...args)}
                  name={svgItems && svgItems[index]}
                  isDesktop={isDesktop}
                  setBadgeCnt={setBadgeCnt}
                  isVisible={isVisible}
                />
              )}
              {isVisible && children}
            </BottomDiv>
          </SpacedDiv>
        </Fragment>
      )
    })
  ) : (
    <Spinner />
  )
}

const BottomDiv = styled.div`
  display: flex;
  flex-direction: row;
`
const SpacedDiv = styled(FlexDiv)`
  // padding-bottom: 40px;
  // margin-bottom: 40px;
  // border-bottom: 1px solid ${grayLight30};
  &:last-child {
    margin-bottom: 0px;
    padding-bottom: 0px;
    border-style: none;
  }
`
